import { connect } from 'react-redux';
import _ from 'lodash';

function FormattedRemoteHTMLMessage({ remoteContent, id }) {
    const content = _.get(remoteContent, id, null);
    return content;
}

function mapStateToProps(state) {
    return ({
        remoteContent: _.get(state, 'serverData.remoteContent', {})
    });
}

export default connect(mapStateToProps)(FormattedRemoteHTMLMessage);
